import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=1a95db54&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=1a95db54&scoped=true&lang=css&"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=1a95db54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95db54",
  null
  
)

export default component.exports